import Tooltip, { type TooltipProps } from "@mui/material/Tooltip";
import { type FC } from "react";
import theme from "src/styles/theme";

export const ErrorTooltip: FC<TooltipProps> = ({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    slotProps={{
      tooltip: {
        sx: {
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.contrastText,
          boxShadow: theme.shadows[1],
          fontSize: 12,
        },
      },
    }}
  />
);
